/* global G */
import { curry } from 'lib/util'
import persistChange from 'app/_shared/events/persist/change'
import { actionWithHooks } from 'lib/sequence/module/action'

/**
 * Event Handler Persist Change and Action
 *
 * It executes persistChange event handler,
 * followed by module action sequence actionWithHooks()
 *
 * It used in cases, where you want to reapply changes to UI, based on field state
 *
 * @param {Gaia.AppModule.Spec} module  the current module composition object
 * @param {Gaia.Component.Spec} component  the current action's main component
 * @param {Event} event                 the event object that triggered this handler
 * @returns {Promise<void>}
 */
const persistChangeAndAction = async (module, component, event) => {
  try {
    persistChange(module, component, event)
    // call same action, see side effects
    await actionWithHooks(module[G.STATE][G.ACTION])([])
  } catch (e) {
    console.error(e)
  }
}

export default curry(persistChangeAndAction)
